import { render } from "./education.vue?vue&type=template&id=64ae3b3f&scoped=true"
import script from "./education.vue?vue&type=script&lang=js"
export * from "./education.vue?vue&type=script&lang=js"

import "./education.vue?vue&type=style&index=0&id=64ae3b3f&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ae3b3f"]])

export default __exports__